import React from "react";
import { Countries } from "../../../../../components/public/Home/CountryFlag";

function countryCodeToName(countryCode) {
  const country = Countries.find(c => c.code === countryCode);
  return country ? country.name : null;
}

export const EditCardItems = ({ heading, icon, subHeading }) => {
  return (
    heading == 'work email' ?
      <div className="flex justify-start items-center p-1 gap-2 relative text-slate">
        <div className="w-full h-10 rounded-full bg-white/[.2] max-w-[2.5rem] flex justify-center items-center">
          {icon}
        </div>
        <div className="text-left">
          <span className="text-f12 text-slate text-left capitalize">
            {heading}
          </span>
          <p className="text-f16 text-slate text-left">{subHeading}</p>
        </div>
      </div> :
      <div className="flex justify-start items-center p-1 gap-2 relative text-slate">
        <div className="w-full h-10 rounded-full bg-white/[.2] max-w-[2.5rem] flex justify-center items-center">
          {icon}
        </div>
        <div className="text-left">
          <span className="text-f12 text-slate text-left capitalize">
            {heading == 'work mobile' ? 'work phone' : heading}
          </span>
          <p className="text-f16 text-slate text-left capitalize">{
            (heading === 'nationality' && subHeading && subHeading.length <= 2)
              ? countryCodeToName(subHeading)
              : (subHeading || '-')
          }</p>
        </div>
      </div>
  );
};
